// d:\项目\搏忆购PC\boyigou_web_new\src\router\routes.js
export default [{
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: () => import('../views/ForgetPassword.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About.vue')
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('../views/Feedback.vue')
  },
  {
    // 商品详情页
    path: '/ShopDetails',
    name: 'ShopDetails',
    component: () => import('../views/ShopDetails/ShopDetails.vue')
  },
  {
    // 店铺详情页
    path: '/StoreDetails',
    name: 'StoreDetails',
    component: () => import('../views/ShopDetails/StoreDetails.vue')
  },
  {
    // 行情详情页
    path: '/MarketDetails',
    name: 'MarketDetails',
    component: () => import('../views/ShopDetails/MarketDetails.vue')
  },
  {
    // 发布采购订单
    path: '/FabuCaigou',
    name: 'FabuCaigou',
    component: () => import('../views/purchase/FabuCaigou.vue'),
  },
  {
    // 发布采购订单成功页
    path: '/FabuSuccess',
    name: 'FabuSuccess',
    component: () => import('../views/purchase/FabuSuccess.vue'),
  },
  {
    // 预下单
    path: '/purchase',
    name: 'purchase',
    component: () => import('../views/purchase/purchase.vue'),
  },
  {
    // 支付页面
    path: '/Payment',
    name: 'Payment',
    component: () => import('../views/Payment/Payment.vue'),
  },
  {
    // 支付成功页
    path: '/payment-success',
    name: 'payment-success',
    component: () => import('../views/Payment/payment-success.vue'),
  },

  // 发布推广页
  {
    path: '/FabuTuiguang',
    name: 'FabuTuiguang',
    component: () => import('../views/purchase/FabuTuiguang.vue'),
  },
  // 推广详情页
  {
    path: '/TuiguangDetails',
    name: 'TuiguangDetails',
    component: () => import('../views/purchase/TuiguangDetails.vue'),
  },

  // 博弈学堂详情页
  {
    path: '/boyixuetang',
    name: 'boyixuetang',
    component: () => import('../views/ShouyeDetails/boyixuetang.vue'),
  },
  //发布评价
  {
    path: '/FabuEvaluate',
    name: 'FabuEvaluate',
    component: () => import('../views/Evaluate/FabuEvaluate.vue'),
  },
  // 查看评价
  {
    path: '/ViewEvaluate',
    name: 'ViewEvaluate',
    component: () => import('../views/Evaluate/ViewEvaluate.vue'),
  },

  // 申请售后   
  {
    path: '/ShenqingShouhou',
    name: 'ShenqingShouhou',
    component: () => import('../views/Shouhou/ShenqingShouhou.vue'),
  },
  // 买家中心
  {
    path: '/buyer',
    name: 'buyerCenter',
    component: () => import('../views/shopCenter/buyer.vue'),
  },
  // 卖家中心
  {
    path: '/seller',
    name: 'sellerCenter',
    component: () => import('../views/shopCenter/seller.vue'),
  }, 
  // 采购详情页
  {
    path: '/PurchaseDetails',
    name: 'PurchaseDetails',
    component: () => import('../views/purchase/PurchaseDetails.vue'),
  },
  // 采购报价页
  {
    path: '/PurchaseQuotation',
    name: 'PurchaseQuotation',
    component: () => import('../views/purchase/PurchaseQuotation.vue'),
  },
  // 用户投诉页
  {
    path: '/Complaint',
    name: 'Complaint',
    component: () => import('../views/Complaint.vue'),
  },
  // GoEasy 会话列表（聊生意）
  {
    path: '/message',
    name: 'message',
    component: () => import('../views/Message/ConversationList.vue'),
  },
]